import React from 'react';
import {Link} from 'react-router-dom';
import {HomeContainer,Container,GradientExplore,MainTitle,MainCaption,GradientTitle,GradientButton,GradientImage,Image,Button} from '../../styles/Home-Styles.js';

const Home = () =>{
    return(
  <HomeContainer>
    <Container>
      <GradientExplore>
        <GradientTitle><MainTitle>Gradients</MainTitle><MainCaption>Beautiful Gradients For Your Next Project</MainCaption></GradientTitle>
        <GradientButton><Link to="/explore"><Button>Explore</Button></Link></GradientButton>
      </GradientExplore>
      <GradientImage><Image></Image></GradientImage>
    </Container>
</HomeContainer>
)}

export default Home;